import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Send } from "lucide-react";
import { FaInstagram, FaFacebookSquare } from "react-icons/fa";
import "@fontsource/chivo";
import "@fontsource/dancing-script/400.css";

const Contatti = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, amount: 0.3 }}
      className="w-full px-6 py-16 bg-white text-center"
    >
      <h2 className="text-4xl sm:text-5xl font-[chivo] mb-12">
        <span className="text-[#00B8C0]">Contatti</span>
      </h2>

      {/* Contact Info */}
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-12 mb-10">
        <div className="flex flex-col items-center space-y-4">
          <MapPin size={60} />
          <p className="text-lg font-[chivo]">
            Marina di Vico, 80069 <br />
            Vico Equense (NA)
          </p>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <Phone size={60} />
          <p className="text-lg font-[chivo]">+39 334 947 8782</p>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <Send size={60} />
          <p className="text-lg font-[chivo]">
            davittoriovicoequense@gmail.com
          </p>
        </div>
      </div>

      {/* Social Icons */}
      <div className="flex justify-center gap-6 mb-12">
        <a
          href="https://www.instagram.com/lidodavittorio/?hl=it"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram
            size={32}
            className="text-pink-500 hover:scale-110 transition duration-300"
          />
        </a>
        <a
          href="https://www.facebook.com/lidovittorio/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookSquare
            size={32}
            className="text-blue-600 hover:scale-110 transition duration-300"
          />
        </a>
      </div>

      {/* Google Map */}
      <div className="w-full max-w-6xl mx-auto">
        <iframe
          title="Lido Da Vittorio Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2508.3885605046166!2d14.428253723454722!3d40.665547333732434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b98591fd31d57%3A0x9b718d48f5fbd9d9!2sLido%20Da%20Vittorio!5e0!3m2!1sit!2spl!4v1623277243593!5m2!1sit!2spl"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="rounded-xl shadow-md"
        ></iframe>
      </div>
    </motion.section>
  );
};

export default Contatti;
